import { NotificationType } from './NotificationType';

export interface Notification {
  message: string;
  duration: number;
  shouldBeTranslated: boolean;
  type: NotificationType;
}
